<template>
  <div>
    <b-table
      class="mb-0"
      striped
      small
      hover
      responsive
      :items="innerValue.subscriptions"
      :fields="fields"
      :show-empty="innerValue.subscriptions && !innerValue.subscriptions.length"
      :empty-text="$gettext('no results found')"
    >
      <template v-slot:head(buttons)>
        <b-btn
          variant="outline-primary"
          size="sm"
          class="float-right"
          @click="edit()">
          <fa-icon icon="plus"/>
          <translate>add</translate>
        </b-btn>
      </template>
      <template v-slot:cell(buttons)="{ index }">
        <edit-delete-buttons
          @edit="edit(index)"
          @remove="remove(index)"
        />
      </template>
    </b-table>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      button-size="sm"
      size="lg"
      ref="modal"
      :lazy="true"
      :title="objIndex !== undefined ? $gettext('edit') : $gettext('add')"
      @ok.prevent="save"
      >
      <template v-slot:modal-footer>
        <modal-buttons
          :type="objIndex !== undefined ? 'update' : 'add'"
          @save="save"
          @cancel="cancel"
        />
      </template>
      <ValidationObserver ref="modalForm" slim>
        <Form
          v-model="obj"
          :paymentPlans="paymentPlans"
          @save="save"/>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable prefer-destructuring */
import vModelMixin from '@/shared/mixins/v-model'
import cloneDeep from 'lodash/cloneDeep'
import uniqueId from 'lodash/uniqueId'
import Form from './SubscriptionEdit.vue'

export default {
  components: {
    Form,
  },
  mixins: [vModelMixin],
  props: {
    paymentPlans: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sortBy: null,
      sortDirection: null,
      fields: [
        {
          key: 'payment_plan.name',
          label: this.$gettext('payment plan'),
        },
        {
          key: 'start_date',
          label: this.$gettext('start date'),
          formatter: (value) => this.$options.filters.date(value),
        },
        {
          key: 'end_date',
          label: this.$gettext('end date'),
          formatter: (value) => this.$options.filters.date(value),
        },
        { key: 'buttons', label: '' },
      ],
      objIndex: null,
      obj: {},
    }
  },
  methods: {
    edit(index) {
      this.objIndex = index
      if (index !== undefined) this.obj = cloneDeep(this.innerValue.subscriptions[index])
      else {
        this.obj = {
          id: -uniqueId(),
          payment_plan: {
            agency_access: [],
            etrip_access: [],
            users_limit: null,
            name: '',
            subscription_pricing_models: [{
              fee: null,
              currency_code: '',
            }],
          },
        }
      }
      this.$refs.modal.show()
    },
    async remove(index) {
      const accepted = await this.$confirmModal()

      if (accepted) {
        this.innerValue.subscriptions.splice(index, 1)
        this.$toastDeleteSuccess()
      }
    },
    async save() {
      const isValid = await this.$refs.modalForm.validate()
      if (isValid) {
        if (this.objIndex !== undefined) {
          this.innerValue.subscriptions.splice(this.objIndex, 1, this.obj)
        } else {
          this.innerValue.subscriptions.push(this.obj)
        }
        this.$toastSaveSuccess()
        this.cancel()
      } else {
        this.$toastInvalidForm()
      }
    },
    cancel() {
      this.$refs.modal.hide()
    },
  },
}
</script>
